const TOOLBAR_CONTAINER = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ font: [] }],
  [{ size: ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }, { 'list': 'check' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ align: [] }],
  ['blockquote', 'code-block'],
  ['link', 'image', 'video', 'formula'],
  ['clean']
];

export const quillModules = {
    toolbar: TOOLBAR_CONTAINER,
    clipboard: {
      matchVisual: false,
    },
  };

  // Factory cho phép gắn custom image handler (upload ảnh lên server thay vì base64 inline).
  // imageHandler là hàm xử lý khi bấm nút ảnh trên toolbar.
  export const makeQuillModules = (imageHandler) => ({
    toolbar: {
      container: TOOLBAR_CONTAINER,
      handlers: imageHandler ? { image: imageHandler } : {},
    },
    clipboard: {
      matchVisual: false,
    },
  });

  export const quillFormats = [
    'header',
    'font',
    'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'bullet',
    'script',
    'indent',
    'direction',
    'align',
    'blockquote', 'code-block',
    'link', 'image', 'video', 'formula'
  ];